<div
  class="med-search-bar"
  [ngClass]="classList"
>
  <med-input
    role="searchbox"
    [size]="size"
    [label]="label"
    [placeholder]="placeholder"
    [inputClass]="inputClassList"
    [hasErrorPadding]="false"
    [disabled]="disabled"
    [(ngModel)]="value"
    (onBlur)="handleElementBlur($event)"
    (click)="showOverlay()"
    (onFocus)="handleElementFocus()"
  >
    <div class="med-search-bar__nav">
      <div
        *ngIf="!hideClearBtn"
        [ngClass]="{ hide: !hasValue }"
        class="med-search-bar__icon med-search-bar__icon--delete"
      >
        <med-icon-x
          size="14"
          (click)="clear()"
        ></med-icon-x>
      </div>

      <div
        *ngIf="loading; else searchIconTemplate"
        class="med-search-bar__icon med-search-bar__icon--sync"
      >
        <med-icon-sync
          size="20"
          class="animate--rotate"
        ></med-icon-sync>
      </div>
    </div>
  </med-input>

  <ul
    *ngIf="overlayVisible"
    role="listbox"
    class="med-search-bar__row med-search-bar__list"
  >
    <li
      *ngIf="options && !options.length"
      class="med-search-bar__message"
    >
      <span class="med-search-bar__message-content">
        {{ emptyMessage }}
      </span>
    </li>

    <li
      *ngFor="let option of options"
      class="med-search-bar__list-item"
      [attr.tabindex]="disabled || option.disabled ? null : '0'"
      (keydown)="onOptionKeydown($event)"
      (click)="handleSelect(option)"
    >
      <ng-container *ngIf="optionTemplate; else defaultOptionTemplate">
        <ng-container *ngTemplateOutlet="optionTemplate.template; context: { $implicit: option }"></ng-container>
      </ng-container>

      <ng-template #defaultOptionTemplate>
        <span class="med-search-bar__list-content">{{ option.label }}</span>
      </ng-template>
    </li>
  </ul>
</div>

<ng-template #searchIconTemplate>
  <div class="med-search-bar__icon med-search-bar__icon--search">
    <med-icon-search
      size="20"
      (click)="search.emit(value)"
    ></med-icon-search>
  </div>
</ng-template>
